import { match } from "react-router";
import { resources, models, createSelectorRx, kea, componentToRx } from "app/main/std";
import React = require("react");
import { observeResource } from "kea-resource";
import * as history from "app/main/history";
import { columnas } from "./columns";

interface Props {
    match: match<{ id: string }>
}

const resource = resources.BitacoraRAD;

export class BitacoraStatusRADList extends React.PureComponent<Props> {
     filtro = (props: Props) => Number.parseInt( props.match.params.id);
     observable = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resource.QueryStatus, filtro);
        return obs;
    });

    onRegresar = () => history.go("../../");
    onAgregar = () => history.go("./new");

    render() {
        const cols = columnas;
        const observable = this.observable(this.props);

        return (
            <div>
                <kea.Title titulo="Historial de status" onRegresar={this.onRegresar} />
                <kea.Grid2 columnas={cols} cookieKey={"BitacoraStatusRADListKey"} items={observable} />
            </div>
        );
    }
}
 


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/status/index.tsx